import { useIsAuthenticated } from '@azure/msal-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useAccountContext from '../../authentication/hooks';
import Layout from '../../components/Layout';
import TermsAndConditionModal from '../../components/modals/TermsAndCondition';
import BranchSelectorModal from '../../components/modals/BranchSelectorModal';
import RouteChangeScrollTop from '../../components/Utilities/routeChangeScrollTop';
import BackToTopButton from '../../components/Utilities/backToTopButton';
import RouteAccessibleNavigation from '../../components/Utilities/routeAccessibleNavigation';

export interface PreConditionsProps {
    children: any;
    displayHeaderAndFooter?: boolean | true;
}

const PreConditions = (props: PreConditionsProps) => {
    const { children, displayHeaderAndFooter } = props;
    const isAuthenticated = useIsAuthenticated();
    const account = useAccountContext();
    const location = useLocation();
    const path = location.pathname;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const redirectToCreateAccount = isAuthenticated
    && account
    && account.details
    && account.details.defaultOrganisationId !== null
    && account.details.accountCreationCompleted === false
    && path?.indexOf('create-account') === -1;

    const redirectToCreateContact = isAuthenticated
    && !redirectToCreateAccount
    && account
    && account.details
    && account.details.accountContactCompleted === false
    && path?.indexOf('create-contact') === -1
    && path?.indexOf('create-account') === -1;

    const redirectToServicesWeOffer = isAuthenticated
    && account
    && account.details
    && account.details.accountCreationCompleted === true
    && account.details.accountContactCompleted === true
    && path?.indexOf('create-account') !== -1
    && path?.indexOf('create-contact') !== -1;

    const showTermsAndConditions = isAuthenticated
    && account
    && account.details
    && account.details.userAcceptedTermsOfUse === false;

    const showBranchSelector = (isAuthenticated
    && account
    && account.details
    && account.details.userAcceptedTermsOfUse === true
    && account.details.defaultOrganisationId === null
    && account.details.accountContactCompleted === true
    && path?.indexOf('success-creating-account') === -1)
    || (account?.details?.showBranchSelector === true);

    // console.log('redirectToCreateAccount : %s', redirectToCreateAccount);
    // console.log('redirectToCreateContact : %s', redirectToCreateContact);
    // console.log('redirectToDashboard : %s', redirectToDashboard);

    if (showBranchSelector && account?.details?.showBranchSelector === false) {
        account?.setShowBranchSelector(true);
    }

    useEffect(() => {
        setIsModalOpen(
            // List and check all Actionable modals across portal app
            !!(showBranchSelector || showTermsAndConditions),
        );

        // For debugging Modals
        // if ((account?.details) !== undefined) {
        //     console.clear();
        //     console.log(`Show terms dialog: ${showTermsAndConditions}`);
        //     console.log(`Branch dialog: ${showBranchSelector}`);
        //     console.log(`RFQDelete dialog: ${showRFQDelete}`);
        //     console.log(`iSModalopen: ${isModalOpen}`);
        // }
    }, [showBranchSelector, showTermsAndConditions, isModalOpen]);

    const renderWithLayout = () => (
        <Layout>
            {children}
            {showTermsAndConditions
                ? <TermsAndConditionModal />
                : null}
            {showBranchSelector
                ? <BranchSelectorModal />
                : null}
        </Layout>
    );

    const renderWithoutLayout = () => (
        <>
            {children}
            {showTermsAndConditions
                ? <TermsAndConditionModal />
                : null}
            {showBranchSelector
                ? <BranchSelectorModal />
                : null}
            <BackToTopButton />
            <RouteAccessibleNavigation />
            <RouteChangeScrollTop />
        </>
    );

    if (redirectToCreateAccount) {
        return <Navigate to='/create-account' />;
    }

    if (redirectToCreateContact) {
        return <Navigate to='/create-contact' />;
    }

    if (redirectToServicesWeOffer) {
        return <Navigate to='/services-we-offer' />;
    }

    return (
        // For WCAG - DIV wrapper work around for HTML "inert' tag not yet included in ReactJS v18
        <div {...{ inert: isModalOpen ? '' : undefined }}>
            {displayHeaderAndFooter
                ? renderWithLayout()
                : renderWithoutLayout()}
        </div>
    );
};

export default PreConditions;
